import * as config from 'common/config';
import { prompts, locales } from './root/localisation';

const LOCALISATIONS_LOADED = 'LOCALISATIONS_LOADED';
const initialState = {
  prompts: {},
  locales: {},
};

export const actionCreators = {
  loadLocalisationConfigs: () => async (dispatch, getState) => {
    const conf = config;
    //load region specific localisation config based on locale, overriding root localisation
    const localisationsFile = await import(`./${conf.locale}/localisation.js`);
    dispatch({ type: LOCALISATIONS_LOADED, data: localisationsFile });
  },
};

export const reducer = (state, action) => {
  state = state || initialState;
  if (action.type === LOCALISATIONS_LOADED) {
    return {
      ...state,
      prompts: { ...prompts, ...action.data.prompts },
      locales: { ...locales, ...action.data.locales },
    };
  }

  return state;
};
